import {
  AGREE_TERMS_SUCCESS,
  CLEAR_PRACTICE,
  FETCH_ORGANIZATION_SUCCESS,
  FETCH_PRACTICE_SUCCESS,
  GET_USER_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  UPDATE_ASSIST_SETTINGS,
  UPDATE_PRACTICE_RBL_THRESHOLD,
  UPDATE_PRIMARY_PRACTICE,
  UPDATE_USER_SUCCESS,
  UPDATE_VIDEA_BEACON_CONNECTION_STATUS,
} from './login.constants';

const DEFAULT_STATE = {
  user: {},
  beacon: {},
};

const actionsMap = {
  [AGREE_TERMS_SUCCESS]: handleAgreeTermsSuccess,
  [FETCH_ORGANIZATION_SUCCESS]: handleGetOrganizationSuccess,
  [FETCH_PRACTICE_SUCCESS]: handleGetPracticeSuccess,
  [GET_USER_SUCCESS]: handleGetUserSuccess,
  [LOGIN_SUCCESS]: handleLoginSuccess,
  [LOGOUT_SUCCESS]: handleLogoutSuccess,
  [UPDATE_USER_SUCCESS]: handleUserUpdateSuccess,
  [UPDATE_VIDEA_BEACON_CONNECTION_STATUS]:
    handleUpdateVideaBeaconConnectionStatus,
  [UPDATE_PRIMARY_PRACTICE]: handleUpdatePrimaryPractice,
  [UPDATE_PRACTICE_RBL_THRESHOLD]: handleUpdatePracticeRBLThreshold,
  [UPDATE_ASSIST_SETTINGS]: updateAssistSettings,
  [CLEAR_PRACTICE]: clearPractice,
};

export default function Login(state = DEFAULT_STATE, action = {}) {
  // @ts-expect-error TS(2339): Property 'type' does not exist on type '{}'.
  const { type } = action;
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (actionsMap[type]) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return actionsMap[type](state, action);
  }
  return state;
}

function handleAgreeTermsSuccess(state: any, action: any) {
  const {
    data: { acceptedTermsVersion },
  } = action;

  return {
    ...state,
    user: {
      ...state.user,
      acceptedTerms: true,
      acceptedTermsVersion,
    },
  };
}

function handleGetOrganizationSuccess(state: any, action: any) {
  const { response } = action;
  const { organization: responseData } = response;
  const { data: organizationList } = responseData;

  return {
    ...state,
    user: {
      ...state.user,
      organization: organizationList[0],
    },
  };
}

function handleGetPracticeSuccess(state: any, action: any) {
  const { response } = action;
  const { practice } = response;

  return {
    ...state,
    user: {
      ...state.user,
      practiceFeatureFlags: practice?.flags,
      practice,
    },
  };
}

function handleGetUserSuccess(state: any, action: any) {
  const {
    response: { user: userResponse },
  } = action;
  return {
    ...state,
    user: {
      ...userResponse,
    },
  };
}

function handleLoginSuccess(state: any, action: any) {
  const {
    response: { user },
  } = action;
  return {
    ...state,
    user: { ...user },
  };
}

function handleLogoutSuccess(state: any) {
  return {
    ...state,
    user: {},
  };
}

function handleUserUpdateSuccess(state: any, action: any) {
  const { user } = action;
  return {
    ...state,
    user: {
      ...state.user,
      ...user,
    },
  };
}

function handleUpdateVideaBeaconConnectionStatus(state: any, action: any) {
  const { newStatus, errorMessage } = action.data;

  return {
    ...state,
    beacon: {
      ...state.beacon,
      status: newStatus,
      errorMessage,
    },
  };
}

function handleUpdatePrimaryPractice(state: any, action: any) {
  return {
    ...state,
    user: {
      ...state.user,
      primaryPracticeId: action.payload.practiceId,
      primaryPracticeName: action.payload.practiceName,
    },
  };
}

function handleUpdatePracticeRBLThreshold(state: any, action: any) {
  return {
    ...state,
    user: {
      ...state.user,
      practice: {
        ...state.user.practice,
        rblSettings: {
          ...state.user.practice.rblSettings,
          templateName: action.payload,
        },
      },
    },
  };
}

export function updateAssistSettings(state: any, action: any) {
  const {
    data: { privacyOn, patientListView },
  } = action;
  return {
    ...state,
    user: {
      ...state.user,
      // If defined, update w/ the new values
      ...(typeof privacyOn !== 'undefined' && { privacyOn }),
      ...(!!patientListView && { patientListView }),
    },
  };
}

// For director users, we need to ensure we clear practice state when navigating to the switchboard so we don't see any lingering state
function clearPractice(state: any) {
  return {
    ...state,
    user: {
      ...state.user,
      primaryPracticeId: undefined,
      primaryPracticeName: undefined,
      practiceFeatureFlags: [],
      practice: undefined,
    },
  };
}
